<template>
  <div class="wrapper">
    <div class="content">
      <Nav :isTop="true" />
      <div class="content-wrap" v-loading="loading">
        <div class="content-info">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
            <el-breadcrumb-item :to="{ path: '/contentInfo' }"
              >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ path: '/contentInfoList' }"
              >内容中心</el-breadcrumb-item
            >
            <el-breadcrumb-item>资讯详情</el-breadcrumb-item>
          </el-breadcrumb>

          <div class="content-title">{{ detail.title }}</div>

          <div class="content-createTime">{{ detail.modifyTime }}</div>

          <div class="content-line"></div>

          <div class="content-html" v-html="detail.content"></div>

          <div class="content-pager" v-if="detail.previous || detail.next">
            <div
              class="content-prev pointer"
              :class="{ 'is-disabled': !detail.previous }"
              @click="goDto(detail.previous)"
            >
              <div class="pager">
                <i class="el-icon-arrow-left"></i>上一篇：
              </div>
              <div class="pager-title ell_one">
                {{ (detail.previous && detail.previous.title) || "暂无" }}
              </div>
            </div>
            <div
              class="content-next pointer"
              :class="{ 'is-disabled': !detail.next }"
              @click="goDto(detail.next)"
            >
              <div class="pager-title ell_one">
                {{ (detail.next && detail.next.title) || "暂无" }}
              </div>
              <div class="pager">
                下一篇：<i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>

          <div
            class="content-pager-placeholder"
            v-if="detail.previous || detail.next"
          ></div>
        </div>
        <div class="content-right">
          <!-- 热门推荐 -->
          <div
            class="item-right"
            v-if="detail.hotList && detail.hotList.length > 0"
          >
            <div class="hot-title">热门推荐</div>
            <div class="hot-list">
              <div
                class="hot-item pointer"
                v-for="(hotItem, hotIndex) in detail.hotList"
                :key="hotIndex"
                @click="goDto(hotItem, 'blank')"
              >
                <div class="hot-index">{{ hotIndex + 1 }}</div>
                <div class="hot-subtitle ell_one">
                  {{ hotItem.title }}
                </div>
              </div>
            </div>
            <div
              class="list-empty"
              v-if="detail.hotList && detail.hotList.length === 0"
            >
              <img src="@/assets/img/good/noGood.png" />
              暂无热门1推荐
            </div>
          </div>

          <!-- 关联商品 -->
          <div
            class="related-goods light-scrollbar"
            v-if="detail.itemList && detail.itemList.length"
          >
            <div
              class="goods-item pointer"
              v-for="(item, index) in detail.itemList"
              :key="index"
              @click="goSpu(item)"
            >
              <goodImg class="goodImg" :img="item.fileUrl" />
              <div class="skuName ell_two">{{ item.skuName }}</div>
              <div
                class="sellingPrice"
                v-show="
                  (item.commodityType &&
                    item.commodityType.indexOf('非标') > -1) ||
                  item.sellingPriceExpired
                "
              >
                {{ $t("home.rfq") }}
              </div>
              <div
                class="sellingPrice"
                v-show="
                  item.commodityType &&
                  item.commodityType.indexOf('非标') === -1 &&
                  !item.sellingPriceExpired
                "
              >
                <span class="colon">¥</span>
                {{ item.sellingPrice | formatePrice }}
              </div>
              <div class="line"></div>
              <div
                class="goods-button pointer"
                v-show="
                  item.commodityType &&
                  item.commodityType.indexOf('非标') === -1 &&
                  !item.sellingPriceExpired
                "
                @click.stop="addCart(item, $event)"
              >
                立即加购
              </div>
              <div
                class="goods-button pointer"
                v-show="
                  (item.commodityType &&
                    item.commodityType.indexOf('非标') > -1) ||
                  item.sellingPriceExpired
                "
                @click.stop="addCart(item, $event)"
              >
                加入询价篮
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/views/layout/contentInfo/nav.vue'
import goodImg from '@/components/img'
import { openOther } from '@/utils/index'
import { getAccessToken } from '@/utils/userInfo'
import anime from 'animejs' // 引入
import defaultImg from '@/assets/img/bitmap.png'

export default {
  components: {
    Nav,
    goodImg
  },
  data () {
    return {
      loading: false,
      addLoading: false,
      detail: {}
    }
  },
  watch: {
    '$route.query.id': {
      handler () {
        this.getDetail()
      },
      immediate: true
    }
  },
  methods: {
    // 获取左侧类目
    getDetail () {
      this.loading = true
      this.$http
        .get(
          '/front/oms/openapi/shopping-content-information/detail?id=' +
            this.$route.query.id
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            const detail = res.data || {}

            // 过滤出上架的商品
            detail.itemList = (detail.itemList || []).filter(
              (item) => item.status === 5
            )

            // 过滤非热推的商品
            detail.hotList = (detail.hotList || []).filter((item) => {
              return item.hot && item.id !== detail.id
            })

            this.detail = detail
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 上一篇下一篇
    goDto (dto, jump) {
      if (!dto) return
      if (jump === 'blank') {
        window.open(
          this.$router.resolve({
            path: '/contentInfoDetail',
            query: {
              id: dto.id
            }
          }).href
        )
      } else {
        this.$router.push({
          path: '/contentInfoDetail',
          query: {
            id: dto.id
          }
        })
      }
    },
    // 商品详情页
    goSpu (item) {
      openOther(`goodDetail?spuId=${item.spuId}`)
    },
    addCart (item, event) {
      // 未登录
      if (!getAccessToken()) {
        sessionStorage.setItem('redirectUrl', this.$route.fullPath)
        this.bus.$emit('showLoginDialog')
        return false
      }
      if (this.addLoading) {
        return false
      }
      this.addLoading = true
      const spuId = item.spuId
      const skuId = item.skuId
      // 购物车类型 ==1 是商品购物车，==2 是询价篮
      let shoppingType = '1'
      if (
        (item.commodityType && item.commodityType.indexOf('非标') > -1) ||
        item.sellingPriceExpired
      ) {
        shoppingType = '2'
      }

      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: item.custspId,
          skuId: item.skuId,
          goodsNum: 1
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success('购物车添加成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http
        .post(`/front/consumer/shoppingcart/addShoppingCart`, {
          goodsSpuId: spuId,
          goodsSkuId: skuId,
          goodsNum: 1,
          shoppingType: shoppingType
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }

          // 请求购物车数量
          if (shoppingType === '1') {
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
          }

          // 操作成功提示
          this.$message.success(
            `${this.$t('product.add')} ${
              shoppingType === '1'
                ? this.$t('product.cart')
                : this.$t('product.blanket')
            } ${this.$t('product.success')}`
          )

          // 动画
          // if (shoppingType === '1') {
          //   this.createDraftAnime(item, event)
          // }
        })
        .finally(() => {
          this.addLoading = false
        })
    },
    createDraftAnime (item, event) {
      const fileUrl = item.fileUrl || defaultImg
      const goodImage = event.target.parentNode.querySelector('.el-image') // 获取商品图片
      const cartIcon = document.getElementById('add_cart_nav') // 获取购物车图标
      // 获取商品图片和购物车的位置
      const startRect = goodImage.getBoundingClientRect()
      const endRect = cartIcon.getBoundingClientRect()

      // 创建飞行元素
      const flyImage = document.createElement('img')
      flyImage.src = fileUrl
      flyImage.style.position = 'fixed'
      flyImage.style.width = '160px'
      flyImage.style.height = '122px'
      flyImage.style.objectFit = 'contain'
      flyImage.style.left = `${startRect.left}px`
      flyImage.style.top = `${startRect.top}px`
      flyImage.style.zIndex = 9999
      document.body.appendChild(flyImage)

      // 使用 anime.js 实现飞行动画
      anime({
        targets: flyImage,
        left: `${endRect.left}px`,
        top: `${endRect.top}px`,
        width: '20px',
        height: '20px',
        duration: 1000,
        easing: 'easeInOutQuad',
        complete: () => {
          // 通知购物车
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )

          // 动画完成后移除飞行元素
          document.body.removeChild(flyImage)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  background: #fff;
  font-family: Alibaba PuHuiTi;

  .content {
    width: 1200px;
    min-height: calc(100vh - 120px);

    .content-wrap {
      padding-top: 16px;
      position: relative;

      .content-info {
        width: calc(100% - 407px);
        display: inline-block;
        vertical-align: top;

        .crumbs {
          /deep/ .el-breadcrumb__inner {
            font-size: 14px;
            color: #333333;

            &.is-link {
              color: #9e9e9e;
              font-weight: normal;

              &:hover {
                color: #333;
              }
            }
          }

          /deep/ .el-breadcrumb__separator {
            color: #9e9e9e;
          }
        }

        .content-title {
          margin-top: 32px;
          font-size: 40px;
          font-weight: bold;
          line-height: 55px;
          color: #333333;
          word-break: break-all;
        }

        .content-createTime {
          margin-top: 8px;
          font-size: 14px;
          line-height: 19px;
          color: #999999;
        }

        .content-line {
          background: #2c2c2c;
          margin-top: 32px;
          margin-bottom: 28px;
          height: 1px;
          opacity: 0.1;
        }

        .content-html {
          word-break: break-all;
          min-height: 420px;

          /deep/ img {
            max-width: 100%;
            height: auto;
          }
        }

        .content-pager {
          margin-top: 100px;
          display: flex;
          justify-content: space-between;
          position: absolute;
          bottom: 0;
          width: calc(100% - 407px);

          .content-prev,
          .content-next {
            display: flex;
            font-size: 14px;
            line-height: 19px;
            letter-spacing: normal;
            color: #2c2c2c;
            border-radius: 12px;
            background: #f5f6fa;
            padding: 16px;
            width: calc(50% - 12px);

            &.is-disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }

            .pager {
              color: #2e4c95;
            }

            .pager-title {
              flex: 1;
            }
          }
        }

        .content-pager-placeholder {
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          height: 51px;
        }
      }

      .content-right {
        width: 367px;
        margin-left: 40px;
        display: inline-block;
        vertical-align: top;
        margin-top: 238px;
        position: sticky;
        top: 66px;

        .item-right {
          border-radius: 16px;
          border: 1px solid #f5f6fa;
          padding: 4px 24px;
          margin-bottom: 20px;

          .hot-title {
            padding: 16px 0px;
            font-size: 16px;
            font-weight: bold;
            line-height: 22px;
            color: #2c2c2c;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          }

          .hot-list {
            .hot-item {
              display: flex;
              padding: 16px 0px;
              line-height: 20px;
              border-bottom: 1px solid #f5f6fa;

              .hot-index {
                margin-right: 8px;
                color: #fff;
                background: #2e4c95;
                width: 20px;
                height: 20px;
                text-align: center;
                border-radius: 50%;
              }

              &:nth-child(n + 4) {
                .hot-index {
                  background: #aeb2bb;
                }
              }

              .hot-subtitle {
                flex: 1;
                font-size: 14px;
                line-height: 20px;
                color: #2c2c2c;
              }
            }
          }

          .list-empty {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding-bottom: 16px;
          }
        }

        .related-goods {
          max-height: 804px;
          overflow: auto;
          margin-right: -6px;
          padding-right: 6px;

          .goods-item {
            display: inline-block;
            vertical-align: top;
            width: calc(50% - 2px);
            border-radius: 18px;
            border: 1px solid #f5f6fa;
            padding: 8px 8px 0;
            margin: 0 4px 4px 0;

            &:nth-child(even) {
              margin-right: 0;
            }

            .goodImg {
              width: 100%;
              height: 122px;
              border-radius: 16px;
              overflow: hidden;
              margin-bottom: 12px;

              /deep/ .goodImg {
                width: 100%;
                height: 100%;

                .goodsImg {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .skuName {
              padding: 0 4px;
              font-size: 14px;
              font-weight: bold;
              line-height: 19px;
              color: #2c2c2c;
              word-break: break-all;
              height: 38px;
              margin-bottom: 8px;
            }

            .sellingPrice {
              padding: 0 4px;
              font-size: 16px;
              font-weight: bold;
              line-height: 22px;
              color: #e20e0e;
              margin-bottom: 12px;

              .colon {
                font-size: 14px;
                line-height: 19px;
              }
            }

            .line {
              background: #f6f5fa;
              height: 1px;
            }

            .goods-button {
              padding: 10px;
              text-align: center;
              font-size: 14px;
              line-height: 19px;
              color: #2a54d1;
            }
          }
        }
      }
    }
  }
}
</style>
